import { DBMovement } from '@Movements/Data/DataSource/API/Entity/Movement'
import { MovementRepository } from '@Movements/Data/Repository/MovementRepository'

export interface UpdateMovements {
    execute(movement: DBMovement): Promise<DBMovement>
    getSource(): string
}

export class UpdateMovementUseCase implements UpdateMovements {
    constructor(private repository: MovementRepository) {}
    async execute(movement: DBMovement): Promise<DBMovement> {
        return this.repository.update(movement)
    }
    getSource(): string {
        return this.repository.dataSource.getSource()
    }
}
